import { useI18n } from '@/hooks/useI18n.ts';
import LeadPhoneType from '@/entities/LeadPhoneType.js';

export function usePhoneType() {
    const { t } = useI18n();

    const formatPhoneType = (type: string): string => {
        const typeMap: Record<string, string> = {
            [LeadPhoneType.CELL]: t('call.cell'),
            [LeadPhoneType.HOME]: t('call.home'),
            [LeadPhoneType.WORK]: t('call.work'),
            [LeadPhoneType.OTHER]: t('general.other'),
        };

        return typeMap[type] ?? t('general.unknown');
    };

    return { formatPhoneType };
}
